import React from 'react';
import { cn } from '../../utils/cn';
import logoApp from '../../assets/images/logo_app.png';
import logoAppNoWords from '../../assets/images/logo_app_no_words.png';

const sizeClassName = {
  sm: 'h-10 w-10',
  lg: 'h-36 w-36 md:h-44 md:w-44 lg:h-52 lg:w-52',
};

const logoByVariant = {
  full: logoApp,
  mark: logoAppNoWords,
};

const AppLogo = ({ size = 'sm', variant = 'mark', className }) => {
  return (
    <img
      src={logoByVariant[variant] || logoByVariant.mark}
      alt="neo-modelos"
      className={cn(
        'object-contain flex-shrink-0 select-none',
        sizeClassName[size] || sizeClassName.sm,
        className
      )}
      draggable={false}
    />
  );
};

export default AppLogo;
